{
  "version": 1,
  "asset_id": "262050fb-e140-43a2-b923-e52d75d14555",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/262050fb-e140-43a2-b923-e52d75d14555/stamped-tan-flagstone.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/262050fb-e140-43a2-b923-e52d75d14555/stamped-tan-flagstone.webp",
  "original_filename": "stamped-tan-flagstone.webp",
  "size": 96148,
  "content_type": "image/webp",
  "created_at": "2026-08-16T22:26:39Z"
}
